import axios from "axios";

export type AccountSearch = {
  query: string;
};

export const getBackendUrl = () => {
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  if (typeof window !== "undefined") {
    return window.location.href;
  }
  return "";
};

const baseURL = new URL("/rest", getBackendUrl()).href;
export const client = axios.create({
  baseURL,
  withCredentials: true,
});

// Cancel Token helpers
export const isCancel = axios.isCancel;
export const CancelToken = axios.CancelToken;
